// import userApi from 'src/api/user'
import {
  SET_USER_INFO,
  SET_CHANNEL_INFO,
  SET_VERTIFY_STATE,
  SET_API_LIST,
} from '../types'

const txvLogin = window.txvLogin
const state = {
  userInfo: null,
  nickName: txvLogin.getNick(),
  channelInfo:null,
  vertifyState: 0,
  apiList: [],
}

const actions = {
  getUserInfo ({ commit }) {
    commit(SET_USER_INFO, {
      nickName: txvLogin.getNick(),
      avator: txvLogin.getAvatar(),
      // qq or wx
      loginType: txvLogin.getLoginType()
    })
  }
}

const mutations = {
  [SET_USER_INFO] (state, user) {
    state.userInfo = user
  },
  [SET_CHANNEL_INFO] (state, list) {
    state.channelInfo = list
  },
  [SET_VERTIFY_STATE] (state, status) {
    state.vertifyState = status
  },
  [SET_API_LIST] (state, apiList) {
    state.apiList = apiList
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
